module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('van-pull-refresh', {
    on: {
      "refresh": _vm.onRefresh
    },
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  }, [_c('van-list', {
    attrs: {
      "finished": _vm.finished,
      "finished-text": "没有更多了"
    },
    on: {
      "load": _vm.onLoad
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, _vm._l((_vm.list), function(order, index) {
    return _c('div', {
      key: index,
      staticClass: "row-list",
      on: {
        "click": function($event) {
          return _vm.goDetail(order)
        }
      }
    }, [_c('div', {
      staticClass: "justify-space-flex row-title"
    }, [_c('div', {
      staticClass: "title-left flex-start gray"
    }, [_c('span', [_vm._v(_vm._s(order.name) + "（" + _vm._s(order.phone) + "）")])]), _vm._v(" "), (order.registstatus == 1) ? _c('div', {
      staticClass: "title-right gray"
    }, [_vm._v("\n                提交成功，待审核\n              ")]) : (order.registstatus == 2) ? _c('div', {
      staticClass: "title-right green"
    }, [_vm._v("\n                审核成功\n              ")]) : _c('div', {
      staticClass: "title-right gray"
    }, [_vm._v("\n                审核失败\n              ")])]), _vm._v(" "), _c('div', {
      staticClass: "justify-space-flex row-goods"
    }, [_c('div', {
      staticClass: "row-left flex-start"
    }, [_c('div', {
      staticClass: "goods-detail"
    }, [_c('div', {
      staticClass: "goods-weight gray-light"
    }, [_vm._v("\n                    " + _vm._s(order.danwei) + " "), _c('br'), _vm._v(" "), (order.registstatus == 3) ? _c('span', {
      staticStyle: {
        "color": "#f00"
      }
    }, [_vm._v(_vm._s(order.registstatusdes))]) : _vm._e()])])])]), _vm._v(" "), (order.registstatus == 2) ? _c('div', {
      staticClass: "row-btn"
    }, [_c('div', {
      staticClass: "look-order",
      on: {
        "click": function($event) {
          return _vm.toEdit(order)
        }
      }
    }, [_vm._v("修改信息")]), _vm._v(" "), _c('div', {
      staticClass: "look-order",
      on: {
        "click": function($event) {
          return _vm.toDetail(order)
        }
      }
    }, [_vm._v("查看详情")])]) : _vm._e(), _vm._v(" "), (order.registstatus == 3) ? _c('div', {
      staticClass: "row-btn"
    }, [_c('div', {
      staticClass: "look-order",
      on: {
        "click": function($event) {
          return _vm.toEdit(order)
        }
      }
    }, [_vm._v("修改信息")])]) : _vm._e()])
  }), 0)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "margin": "0 auto"
    },
    attrs: {
      "size": "normal",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.goWenjuan()
      }
    }
  }, [_vm._v("大课间情况调查问卷\n      ")]), _vm._v(" "), (_vm.showClubDakejian) ? _c('van-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'DakejianApplySimple'
      }),
      expression: "{name:'DakejianApplySimple'}"
    }],
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": ""
    }
  }, [_vm._v("新增申报\n      ")]) : _c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "disabled": true,
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": ""
    }
  }, [_vm._v("您已授牌\n      ")])], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f08099ec","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/cdakejian/DakejianList.vue
// module id = 2630
// module chunks = 0